import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Certified Trainees")
  ])
], -1)
const _hoisted_2 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_3 = { class: "collapse show" }
const _hoisted_4 = { class: "card-body border-top p-9" }
const _hoisted_5 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_6 = { class: "row col-12" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  class: "select-tranche"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, "Phases: ", -1)
const _hoisted_11 = {
  key: 1,
  class: "select-entity"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "px-2" }, "And Training Partner: ", -1)
const _hoisted_13 = {
  key: 2,
  class: "select-entity"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "px-2" }, "And Training Institute: ", -1)
const _hoisted_15 = {
  key: 3,
  class: "select-entity"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "px-2" }, "And Batches: ", -1)
const _hoisted_17 = {
  key: 4,
  class: "select-entity"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "px-2" }, "And Course: ", -1)
const _hoisted_19 = {
  key: 5,
  class: "select-entity"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "px-2" }, "And Course Type: ", -1)
const _hoisted_21 = { class: "row col-12" }
const _hoisted_22 = { class: "col-4 mt-16" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, null, -1)
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "card mb-5 mb-xl-2" }
const _hoisted_26 = {
  class: "card-header border-0 cursor-pointer accordion-button",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#tranche",
  "aria-expanded": "true",
  "aria-controls": "form",
  style: {"align-items":"center"}
}
const _hoisted_27 = { class: "card-title m-0" }
const _hoisted_28 = { class: "text-dark m-0" }
const _hoisted_29 = {
  id: "tranche",
  class: "collapse"
}
const _hoisted_30 = { class: "collapse show" }
const _hoisted_31 = {
  class: "card-body border-top",
  style: {"height":"10vh","padding-left":"0px","padding-right":"0px"}
}
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "card mb-5 mb-xl-2" }
const _hoisted_34 = {
  class: "card-header border-0 cursor-pointer accordion-button",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#entity",
  "aria-expanded": "true",
  "aria-controls": "form",
  style: {"align-items":"center"}
}
const _hoisted_35 = { class: "card-title m-0" }
const _hoisted_36 = { class: "text-dark m-0" }
const _hoisted_37 = {
  id: "entity",
  class: "collapse"
}
const _hoisted_38 = { class: "collapse show" }
const _hoisted_39 = {
  class: "card-body border-top",
  style: {"height":"10vh","padding-left":"0px","padding-right":"0px"}
}
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "card mb-5 mb-xl-2" }
const _hoisted_42 = {
  class: "card-header border-0 cursor-pointer accordion-button",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#ti",
  "aria-expanded": "true",
  "aria-controls": "form",
  style: {"align-items":"center"}
}
const _hoisted_43 = { class: "card-title m-0" }
const _hoisted_44 = { class: "text-dark m-0" }
const _hoisted_45 = {
  id: "ti",
  class: "collapse"
}
const _hoisted_46 = { class: "collapse show" }
const _hoisted_47 = {
  class: "card-body border-top",
  style: {"height":"10vh","padding-left":"0px","padding-right":"0px"}
}
const _hoisted_48 = { class: "row" }
const _hoisted_49 = { class: "card mb-5 mb-xl-2" }
const _hoisted_50 = {
  class: "card-header border-0 cursor-pointer accordion-button",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#course_type",
  "aria-expanded": "true",
  "aria-controls": "form",
  style: {"align-items":"center"}
}
const _hoisted_51 = { class: "card-title m-0" }
const _hoisted_52 = { class: "text-dark m-0" }
const _hoisted_53 = {
  id: "course_type",
  class: "collapse"
}
const _hoisted_54 = { class: "collapse show" }
const _hoisted_55 = {
  class: "card-body border-top",
  style: {"height":"10vh","padding-left":"0px","padding-right":"0px"}
}
const _hoisted_56 = { class: "row" }
const _hoisted_57 = { class: "card mb-5 mb-xl-2" }
const _hoisted_58 = {
  class: "card-header border-0 cursor-pointer accordion-button",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#course_list",
  "aria-expanded": "true",
  "aria-controls": "form",
  style: {"align-items":"center"}
}
const _hoisted_59 = { class: "card-title m-0" }
const _hoisted_60 = { class: "text-dark m-0" }
const _hoisted_61 = {
  id: "course_list",
  class: "collapse"
}
const _hoisted_62 = { class: "collapse show" }
const _hoisted_63 = {
  class: "card-body border-top",
  style: {"height":"10vh","padding-left":"0px","padding-right":"0px"}
}
const _hoisted_64 = { class: "row" }
const _hoisted_65 = { class: "card mb-5 mb-xl-2" }
const _hoisted_66 = {
  class: "card-header border-0 cursor-pointer accordion-button",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#batches",
  "aria-expanded": "true",
  "aria-controls": "form",
  style: {"align-items":"center"}
}
const _hoisted_67 = { class: "card-title m-0" }
const _hoisted_68 = { class: "text-dark m-0" }
const _hoisted_69 = {
  id: "batches",
  class: "collapse"
}
const _hoisted_70 = { class: "collapse show" }
const _hoisted_71 = {
  class: "card-body border-top",
  style: {"height":"10vh","padding-left":"0px","padding-right":"0px"}
}
const _hoisted_72 = { class: "row" }
const _hoisted_73 = { class: "card mb-5 mb-xl-2" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer accordion-button",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#gender",
  "aria-expanded": "true",
  "aria-controls": "form",
  style: {"align-items":"center"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "text-dark m-0" }, [
      /*#__PURE__*/_createElementVNode("span", null, " Gender ")
    ])
  ])
], -1)
const _hoisted_75 = {
  id: "gender",
  class: "collapse"
}
const _hoisted_76 = { class: "collapse show" }
const _hoisted_77 = {
  class: "card-body border-top",
  style: {"height":"10vh","padding-left":"0px","padding-right":"0px"}
}
const _hoisted_78 = { class: "row mt-3" }
const _hoisted_79 = { class: "col-md-12" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-restore-alt" }, null, -1)
const _hoisted_81 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_82 = { class: "col-8" }
const _hoisted_83 = { class: "col-md-12 mt-4 pt-4" }
const _hoisted_84 = { class: "row d-flex" }
const _hoisted_85 = { class: "col-md-4" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("h3", null, "Select Header", -1)
const _hoisted_87 = { class: "card mb-5 mb-xl-2" }
const _hoisted_88 = {
  class: "card-header border-0 cursor-pointer accordion-button bg-secondary",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#header",
  "aria-expanded": "true",
  "aria-controls": "form",
  style: {"align-items":"center"}
}
const _hoisted_89 = { class: "card-title m-0" }
const _hoisted_90 = { class: "text-dark m-0" }
const _hoisted_91 = { key: 0 }
const _hoisted_92 = {
  id: "header",
  class: "collapse"
}
const _hoisted_93 = { class: "collapse show" }
const _hoisted_94 = {
  class: "card-body border-top p-9",
  style: {"overflow":"scroll","max-height":"28vh"}
}
const _hoisted_95 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_96 = { class: "row" }
const _hoisted_97 = ["name", "onUpdate:modelValue", "value"]
const _hoisted_98 = ["for"]
const _hoisted_99 = { class: "col-md-5 mt-8" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_101 = {
  key: 0,
  class: "col-md-12 mt-4"
}
const _hoisted_102 = /*#__PURE__*/_createElementVNode("h3", null, "Selected Headers", -1)
const _hoisted_103 = { key: 0 }
const _hoisted_104 = { class: "row" }
const _hoisted_105 = ["onUpdate:modelValue"]
const _hoisted_106 = { class: "row col-12" }
const _hoisted_107 = {
  key: 0,
  class: "row mt-1 w-100 m-0"
}
const _hoisted_108 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" })
], -1)
const _hoisted_109 = {
  class: "col-md-6 mt-1 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_110 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_111 = [
  _hoisted_110
]
const _hoisted_112 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_113 = [
  _hoisted_112
]
const _hoisted_114 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_115 = [
  _hoisted_114
]
const _hoisted_116 = {
  key: 1,
  class: "row"
}
const _hoisted_117 = {
  class: "col-md-12 mt-4",
  id: "dataTable"
}
const _hoisted_118 = { class: "row" }
const _hoisted_119 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_120 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_Form = _resolveComponent("Form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_Form, {
    onSubmit: _cache[14] || (_cache[14] = ($event: any) => (_ctx.formSubmit())),
    class: "form",
    "validation-schema": _ctx.AssociationSchema
  }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "card mb-5 mb-xl-10",
        key: _ctx.componentKey
      }, [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("h4", null, [
                    _createTextVNode(" Showing data for: "),
                    (
                      !_ctx.TranceLabel.length &&
                      !_ctx.TpartnerLabel.length &&
                      !_ctx.TinstituteLabel.length &&
                      !_ctx.TbatchesLabel.length &&
                      !_ctx.TCourseTypeLabel.length &&
                      !_ctx.TCourseListLabel.length
                    )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, " All "))
                      : (_openBlock(), _createElementBlock("span", _hoisted_8, [
                          (_ctx.TranceLabel)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                                _hoisted_10,
                                _createTextVNode(" " + _toDisplayString(_ctx.TranceLabel), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.TpartnerLabel)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                                _hoisted_12,
                                _createTextVNode(" " + _toDisplayString(_ctx.TpartnerLabel), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.TinstituteLabel)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                                _hoisted_14,
                                _createTextVNode(" " + _toDisplayString(_ctx.TinstituteLabel), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.TbatchesLabel)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                                _hoisted_16,
                                _createTextVNode(" " + _toDisplayString(_ctx.TbatchesLabel), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.TCourseListLabel)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                                _hoisted_18,
                                _createTextVNode(" " + _toDisplayString(_ctx.TCourseListLabel), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.TCourseTypeLabel)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                                _hoisted_20,
                                _createTextVNode(" " + _toDisplayString(_ctx.TCourseTypeLabel), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("label", _hoisted_28, [
                              _createElementVNode("span", null, _toDisplayString(this.tranches.length) + " Phase", 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              _createVNode(_component_el_select, {
                                class: "form-select-solid",
                                placeholder: "Select Phase",
                                modelValue: _ctx.TranceData,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.TranceData) = $event)),
                                multiple: "",
                                "collapse-tags": "",
                                filterable: "",
                                style: {"width":"100%"},
                                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.trancheLabelChange(_ctx.TranceData)))
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranches, (trans) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: trans.id,
                                      label: trans.label,
                                      value: trans.id
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(trans.label), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("label", _hoisted_36, [
                              _createElementVNode("span", null, _toDisplayString(this.entityInfos.length) + " Training Partner", 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_37, [
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("div", _hoisted_39, [
                              _createVNode(_component_el_select, {
                                class: "form-select-solid",
                                placeholder: "Select Partner",
                                modelValue: _ctx.TpartnerData,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.TpartnerData) = $event)),
                                multiple: "",
                                "collapse-tags": "",
                                onChange: _ctx.trainingPartnerLabelChange,
                                filterable: "",
                                style: {"width":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (assoc) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: assoc.id,
                                      label: assoc.entity_short_name,
                                      value: assoc.id
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(assoc.entity_name) + " [" + _toDisplayString(assoc?.entity_short_name) + "]", 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "onChange"])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("label", _hoisted_44, [
                              _createElementVNode("span", null, _toDisplayString(this.instituteList.length) + " Training Institute", 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                          _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("div", _hoisted_47, [
                              _createVNode(_component_el_select, {
                                class: "form-select-solid",
                                placeholder: "Select Training Institute",
                                modelValue: _ctx.TinstituteData,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.TinstituteData) = $event)),
                                multiple: "",
                                "collapse-tags": "",
                                onChange: _ctx.trainingInstituteLabelChange,
                                filterable: "",
                                style: {"width":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.instituteList, (assoc) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: assoc.id,
                                      label: assoc.institute_name,
                                      value: assoc.id
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(assoc.institute_name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "onChange"])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("div", _hoisted_51, [
                            _createElementVNode("label", _hoisted_52, [
                              _createElementVNode("span", null, _toDisplayString(this.courseType.length) + " Course Type", 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_53, [
                          _createElementVNode("div", _hoisted_54, [
                            _createElementVNode("div", _hoisted_55, [
                              _createVNode(_component_el_select, {
                                class: "form-select-solid",
                                placeholder: "Select Course Type",
                                modelValue: _ctx.CourseTypeData,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.CourseTypeData) = $event)),
                                multiple: "",
                                "collapse-tags": "",
                                onChange: _ctx.courseTypeLabelChange,
                                filterable: "",
                                style: {"width":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseType, (course) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: course.id,
                                      label: course.type_name,
                                      value: course.id
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(course.type_name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "onChange"])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("div", _hoisted_58, [
                          _createElementVNode("div", _hoisted_59, [
                            _createElementVNode("label", _hoisted_60, [
                              _createElementVNode("span", null, _toDisplayString(this.courseList.length) + " Course List", 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_61, [
                          _createElementVNode("div", _hoisted_62, [
                            _createElementVNode("div", _hoisted_63, [
                              _createVNode(_component_el_select, {
                                class: "form-select-solid",
                                placeholder: "Select Course Type",
                                modelValue: _ctx.CourseListData,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.CourseListData) = $event)),
                                multiple: "",
                                "collapse-tags": "",
                                onChange: _ctx.courseListLabelChange,
                                filterable: "",
                                style: {"width":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseList, (course) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: course.id,
                                      label: course.course_name,
                                      value: course.id
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(course?.course_name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "onChange"])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_64, [
                      _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("div", _hoisted_66, [
                          _createElementVNode("div", _hoisted_67, [
                            _createElementVNode("label", _hoisted_68, [
                              _createElementVNode("span", null, _toDisplayString(this.batchList.length) + " Training Batches", 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_69, [
                          _createElementVNode("div", _hoisted_70, [
                            _createElementVNode("div", _hoisted_71, [
                              _createVNode(_component_el_select, {
                                class: "form-select-solid",
                                placeholder: "Select Partner",
                                modelValue: _ctx.TbatchData,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.TbatchData) = $event)),
                                multiple: "",
                                "collapse-tags": "",
                                onChange: _ctx.tbatchLabelChange,
                                filterable: "",
                                style: {"width":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.batchList, (info) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: info?.id,
                                      label: info?.batch_sequence_number,
                                      value: info.id
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(info?.tranche_info?.short_name) + "-" + _toDisplayString(info?.entity_info?.entity_short_name) + "-" + _toDisplayString(info?.course_info?.course_name) + "-" + _toDisplayString(info?.institute_info?.short_name) + "-" + _toDisplayString(info?.batch_sequence_number), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "onChange"])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_72, [
                      _createElementVNode("div", _hoisted_73, [
                        _hoisted_74,
                        _createElementVNode("div", _hoisted_75, [
                          _createElementVNode("div", _hoisted_76, [
                            _createElementVNode("div", _hoisted_77, [
                              _createVNode(_component_el_select, {
                                class: "form-select-solid",
                                placeholder: "Select Gender",
                                modelValue: _ctx.genderData,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.genderData) = $event)),
                                multiple: "",
                                "collapse-tags": "",
                                filterable: "",
                                style: {"width":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, { value: "Male" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Male")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_option, { value: "Female" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Female")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_78, [
                      _createElementVNode("div", _hoisted_79, [
                        _createElementVNode("button", {
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.resetData())),
                          type: "button",
                          class: "btn btn-danger p-3 mr-4",
                          style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                        }, [
                          _createTextVNode(" Reset "),
                          _hoisted_80
                        ]),
                        _createElementVNode("button", {
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.generatetraineeAdvanceReport())),
                          type: "button",
                          class: "btn btn-success p-3",
                          style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                        }, [
                          _createTextVNode(" Search "),
                          _hoisted_81
                        ])
                      ])
                    ])
                  ]),
                  _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_82, [
                    _createElementVNode("div", _hoisted_83, [
                      _createElementVNode("div", _hoisted_84, [
                        _createElementVNode("div", _hoisted_85, [
                          _hoisted_86,
                          _createElementVNode("div", _hoisted_87, [
                            _createElementVNode("div", _hoisted_88, [
                              _createElementVNode("div", _hoisted_89, [
                                _createElementVNode("label", _hoisted_90, [
                                  (_ctx.headerSelect)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_91, _toDisplayString(_ctx.st.length) + " Selected", 1))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_92, [
                              _createElementVNode("div", _hoisted_93, [
                                _createElementVNode("div", _hoisted_94, [
                                  _createElementVNode("div", _hoisted_95, [
                                    _createElementVNode("div", _hoisted_96, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.certifiedHeader, (info) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          class: "form-check",
                                          key: info.key
                                        }, [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "checkbox",
                                            multiple: "",
                                            name: info.name,
                                            "onUpdate:modelValue": ($event: any) => ((info.selected) = $event),
                                            value: {
                                          name: info.name,
                                          key: info.key,
                                        },
                                            class: "form-check-input"
                                          }, null, 8, _hoisted_97), [
                                            [_vModelCheckbox, info.selected]
                                          ]),
                                          _createElementVNode("label", {
                                            class: "form-check-label",
                                            for: info.name
                                          }, _toDisplayString(info.name), 9, _hoisted_98)
                                        ]))
                                      }), 128))
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_99, [
                          _createElementVNode("button", {
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.generatetraineeAdvanceReport())),
                            type: "button",
                            class: "btn btn-success p-3 mr-4"
                          }, [
                            _createTextVNode(" Search "),
                            _hoisted_100
                          ])
                        ]),
                        (_ctx.showall)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                              _hoisted_102,
                              (_ctx.st.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                                    _createElementVNode("div", _hoisted_104, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.st, (data, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          class: "col-md-4",
                                          key: index
                                        }, [
                                          _withDirectives(_createElementVNode("input", {
                                            class: "btn btn-primary m-1 py-2 px-2 w-100",
                                            "onUpdate:modelValue": ($event: any) => ((data.name) = $event)
                                          }, null, 8, _hoisted_105), [
                                            [_vModelText, data.name]
                                          ])
                                        ]))
                                      }), 128))
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])), [
                    [_directive_loading, _ctx.tableLoad]
                  ])
                ]),
                _createElementVNode("div", _hoisted_106, [
                  (_ctx.showTableData)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                        _hoisted_108,
                        _createElementVNode("div", _hoisted_109, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                            title: "Download Xlse",
                            "data-v-54b12dc8": "",
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.exportTrainee()))
                          }, _hoisted_111),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                            title: "Download PDF",
                            "data-v-54b12dc8": "",
                            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.downloadPdf()))
                          }, _hoisted_113),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                            title: "Print",
                            "data-v-54b12dc8": "",
                            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.printPdf()))
                          }, _hoisted_115)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.showTableData)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
                        _createElementVNode("div", _hoisted_117, [
                          _createElementVNode("div", _hoisted_118, [
                            (_openBlock(), _createElementBlock("div", {
                              key: _ctx.componentTableKey,
                              class: "card-body p-6",
                              "data-v-71816626": "",
                              style: {"border-radius":"1em","border":"2px solid #8dcb8d"}
                            }, [
                              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_119, [
                                _createVNode(_component_Datatable, {
                                  "table-data": _ctx.tableData,
                                  "table-header": _ctx.st,
                                  "enable-items-per-page-dropdown": true
                                }, {
                                  "cell-photo": _withCtx(({ row: industry }) => [
                                    _createElementVNode("img", {
                                      src: 
                                  industry?.trainee_info?.attach_file_info
                                    ?.file_path
                                    ? _ctx.api_url +
                                      industry?.trainee_info?.attach_file_info
                                        ?.file_path
                                    : 'media/avatars/blank.png'
                                ,
                                      alt: "",
                                      width: "32",
                                      height: "32"
                                    }, null, 8, _hoisted_120)
                                  ]),
                                  "cell-association": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.entity_info?.entity_short_name), 1)
                                  ]),
                                  "cell-t_institute": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.institute_info?.short_name), 1)
                                  ]),
                                  "cell-course": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.course_info?.course_name), 1)
                                  ]),
                                  "cell-batch": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.batch_info?.batch_sequence_number), 1)
                                  ]),
                                  "cell-reg_num": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.registration_number), 1)
                                  ]),
                                  "cell-ref_num": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.reference_number), 1)
                                  ]),
                                  "cell-trainee_name": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.trainee_name), 1)
                                  ]),
                                  "cell-father": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.father_name), 1)
                                  ]),
                                  "cell-mother": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.mother_name), 1)
                                  ]),
                                  "cell-gender": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.gender), 1)
                                  ]),
                                  "cell-nid": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.nid), 1)
                                  ]),
                                  "cell-bcn": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.bcn), 1)
                                  ]),
                                  "cell-dob": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.date_of_birth
                                  ? _ctx.moment(
                                      industry?.trainee_info?.date_of_birth
                                    ).format('DD-MM-YYYY')
                                  : ''), 1)
                                  ]),
                                  "cell-mobile": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.mobile), 1)
                                  ]),
                                  "cell-email": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.email), 1)
                                  ]),
                                  "cell-religion": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.religion), 1)
                                  ]),
                                  "cell-reas_date": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.reassessment_date), 1)
                                  ]),
                                  "cell-as_title": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.assessment_title), 1)
                                  ]),
                                  "cell-total_marks": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.total_marks), 1)
                                  ]),
                                  "cell-as_score": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.assessment_score), 1)
                                  ]),
                                  "cell-remarks": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.remarks), 1)
                                  ]),
                                  "cell-atd_percentage": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.attendance_percentage), 1)
                                  ]),
                                  "cell-is_certification": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.is_certification == 1 ? 'Yes' : 'No'), 1)
                                  ]),
                                  "cell-tranche": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.tranche_info?.label), 1)
                                  ]),
                                  "cell-present_add": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.present_address), 1)
                                  ]),
                                  "cell-pre_postcode": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.present_post_code), 1)
                                  ]),
                                  "cell-present_district": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.present_district_info
                                  ?.district_name_eng), 1)
                                  ]),
                                  "cell-pre_upazila": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.present_upazilla_info
                                  ?.upazila_name_eng), 1)
                                  ]),
                                  "cell-permanent_add": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.per_address), 1)
                                  ]),
                                  "cell-per_postcode": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.per_post_code), 1)
                                  ]),
                                  "cell-permanent_district": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.permanent_district_info
                                  ?.district_name_eng), 1)
                                  ]),
                                  "cell-per_upazila": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.permanent_upazilla_info
                                  ?.upazila_name_eng), 1)
                                  ]),
                                  "cell-home_dist": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.home_district_info
                                  ?.district_name_eng), 1)
                                  ]),
                                  "cell-home_upazila": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.home_upazilla_info
                                  ?.upazila_name_eng), 1)
                                  ]),
                                  "cell-alt_mobile": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.alternative_mobile), 1)
                                  ]),
                                  "cell-ethnic": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.ethnic_group_info
                                  ?.group_name), 1)
                                  ]),
                                  "cell-hcc": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.highest_class_completed), 1)
                                  ]),
                                  "cell-hccy": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info
                                  ?.highest_class_completed_year), 1)
                                  ]),
                                  "cell-is_employed": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.is_employed), 1)
                                  ]),
                                  "cell-year_of_exp": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.year_of_experience), 1)
                                  ]),
                                  "cell-fmi": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.family_monthly_income), 1)
                                  ]),
                                  "cell-ipc": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.is_physically_challenged), 1)
                                  ]),
                                  "cell-cr": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.challenge_remarks), 1)
                                  ]),
                                  "cell-mel": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.mother_education_level), 1)
                                  ]),
                                  "cell-mother_ocu": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.mother_occupation), 1)
                                  ]),
                                  "cell-fel": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.father_education_level), 1)
                                  ]),
                                  "cell-f_occupation": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.father_occupation), 1)
                                  ]),
                                  "cell-fai": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.father_annual_income), 1)
                                  ]),
                                  "cell-hfoh": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.have_family_owned_home), 1)
                                  ]),
                                  "cell-hfol": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.have_family_owned_land), 1)
                                  ]),
                                  "cell-bank_name": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.bank_name), 1)
                                  ]),
                                  "cell-nos": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.number_of_siblings), 1)
                                  ]),
                                  "cell-bbn": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.bank_branch_name), 1)
                                  ]),
                                  "cell-brn": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.bank_routing_no), 1)
                                  ]),
                                  "cell-ban": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.bank_account_number), 1)
                                  ]),
                                  "cell-account_type": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.account_type), 1)
                                  ]),
                                  "cell-x_bank": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.x_bank_info?.bank_name), 1)
                                  ]),
                                  "cell-x_mobile_banking": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.x_mobile_banking_info
                                  ?.name), 1)
                                  ]),
                                  "cell-mbn": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.x_mobile_banking_info
                                  ?.name), 1)
                                  ]),
                                  "cell-mbp": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.x_mobile_banking_info
                                  ?.prefix), 1)
                                  ]),
                                  "cell-abn": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.agent_bank_info
                                  ?.bank_name), 1)
                                  ]),
                                  "cell-batch_start_date": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.batch_info?.start_date
                                  ? _ctx.moment(
                                      industry?.trainee_info?.batch_info
                                        ?.start_date
                                    ).format('DD-MM-YYYY')
                                  : ''), 1)
                                  ]),
                                  "cell-batch_end_date": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.batch_info?.end_date
                                  ? _ctx.moment(
                                      industry?.trainee_info?.batch_info
                                        ?.end_date
                                    ).format('DD-MM-YYYY')
                                  : ''), 1)
                                  ]),
                                  "cell-att_perc": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.attendance_percentage), 1)
                                  ]),
                                  "cell-sfs": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.selected_for_stipend ==
                                1
                                  ? 'Selected'
                                  : 'Not Selected'), 1)
                                  ]),
                                  "cell-sel-date": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.selection_date
                                  ? _ctx.moment(
                                      industry?.trainee_info?.selection_date
                                    ).format('DD-MM-YYYY')
                                  : ''), 1)
                                  ]),
                                  "cell-bank_ver": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.bank_verified == 1
                                  ? 'Yes'
                                  : 'No'), 1)
                                  ]),
                                  "cell-ver-date": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.verification_date
                                  ? _ctx.moment(industry?.verification_date).format(
                                      'DD-MM-YYYY'
                                    )
                                  : ''), 1)
                                  ]),
                                  "cell-stip-disburse": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.stipend_disbursed == 1
                                  ? 'Yes'
                                  : 'No'), 1)
                                  ]),
                                  "cell-disb-date": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.disbursement_date
                                  ? _ctx.moment(
                                      industry?.trainee_info?.disbursement_date
                                    ).format('DD-MM-YYYY')
                                  : ''), 1)
                                  ]),
                                  "cell-disb_amount": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.disbursed_amount), 1)
                                  ]),
                                  "cell-dib_remarks": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.disbursement_remarks), 1)
                                  ]),
                                  "cell-is_poor": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.is_poor == 0
                                  ? 'Yes'
                                  : 'No'), 1)
                                  ]),
                                  "cell-sti-year": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.stipend_year), 1)
                                  ]),
                                  "cell-sti-quarter": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.stipend_quarter), 1)
                                  ]),
                                  "cell-sti-start-date": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.stipend_start_date
                                  ? _ctx.moment(
                                      industry?.trainee_info?.stipend_start_date
                                    ).format('DD-MM-YYYY')
                                  : ''), 1)
                                  ]),
                                  "cell-sti-end-date": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.stipend_end_date
                                  ? _ctx.moment(
                                      industry?.trainee_info?.stipend_end_date
                                    ).format('DD-MM-YYYY')
                                  : ''), 1)
                                  ]),
                                  "cell-income_cert": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.income_certificate
                                  ? 'Yes'
                                  : 'No'), 1)
                                  ]),
                                  "cell-trainee_remarks": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.trainee_remarks), 1)
                                  ]),
                                  "cell-bank_v_r": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info
                                  ?.bank_verification_remarks), 1)
                                  ]),
                                  "cell-allow_dup_enroll": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.dup_enrollment), 1)
                                  ]),
                                  "cell-eligible_dup_course": _withCtx(({
                                row: industry,
                              }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info
                                  ?.eligible_duplicate_course_ids), 1)
                                  ]),
                                  "cell-sti_count": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.trainee_info?.stipend_count), 1)
                                  ]),
                                  "cell-cer_date": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.recertification_date
                                  ? _ctx.moment(industry?.certification_date).format(
                                      'DD-MM-YYYY'
                                    )
                                  : ''), 1)
                                  ]),
                                  "cell-recert-date": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.recertification_date
                                  ? _ctx.moment(
                                      industry?.recertification_date
                                    ).format('DD-MM-YYYY')
                                  : ''), 1)
                                  ]),
                                  "cell-final-grade": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.final_grade), 1)
                                  ]),
                                  "cell-pass-percentage": _withCtx(({ row: industry }) => [
                                    _createTextVNode(_toDisplayString(industry?.pass_percentage), 1)
                                  ]),
                                  _: 1
                                }, 8, ["table-data", "table-header"])
                              ])), [
                                [_directive_loading, _ctx.tableLoad]
                              ])
                            ]))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ])
      ])), [
        [_directive_loading, _ctx.load]
      ])
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}